<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog">
        <!-- 详细信息 -->
        <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
        <div class="detailClass">
            <BaseList @saveDecFn="confrimFn" :baseMsgArray="baseMsgArray" :detailObj="detailObj" :isMode="isMode" />
            <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
            <!-- <changeIcon :isMode="isMode" @modeChange="modeChange" /> -->
        </div>
        <Tabs :tabs="tabsArray" :activeCom.sync="tabsActive" />
        <!-- <NetParam :detailNetObj="netArray" /> -->
        <keep-alive>
            <component :is="tabsActive" v-bind="$attrs" :detailNetObj="netArray" />
        </keep-alive>
        <div slot="footer">
            <el-button type="primary" v-if="detailObj.isHeart === 1" @click="hearFn">{{ $t('device.heartbeat_history') }}
            </el-button>
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        </div>
        <!-- 心跳弹窗 -->
        <HearDialog :append-to-body="true" :totalAll="totalAll" :title="hearTitle" :isShow.sync="isShow"
            :tableData="tableData" :mac="hearQuery.mac" />
    </modal>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue';
import NetParam from '@/pages/equipment/publicCom/NetParam.vue';
import Application from '@/pages/equipment/publicCom/Application.vue';
// import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Upload from '@/pages/equipment/publicCom/Upload.vue';
import BaseList from './detail/BaseList.vue'
import HearDialog from './hearDialog.vue';
import { gatewayhistoryList, gatewayUpdate } from '@/api/modules/gateway.js'
export default {
    props: ['title', 'isDetailShow', 'netObj', 'detailObj'],
    components: {
        Tabs,
        Upload,
        BaseList,
        // changeIcon,
        NetParam,
        Application,
        HearDialog
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isDetailShow
            },
            set: function (val) {
                this.$emit('update:isDetailShow', val);//可以优化成model  或者minx
            }
        },
    },
    watch: {
        netObj(newVal) {
            this.netArray.forEach(item => {
                item.content = newVal[item.key]
            })
            this.isMode = false;
        },
        detailObj(newVal) {
            this.isMode = false;
            console.log(newVal);
            this.Upload = {
                imageUrl: { ...newVal }.pictureBase64,
                // 图片后缀
                imageSuffix: { ...newVal }.pictureSuffix,
            }
        }
    },
    data() {
        return {
            detailTbs: [
                {
                    name: 'Detail',
                    label: this.$t('public.detail_info')
                }
            ],
            Dactive: 'Detail',
            tabsArray: [
                {
                    name: 'Application',
                    label: 'public.attribute'
                },
                {
                    name: 'NetParam',
                    label: 'public.net_param'
                }
            ],
            tabsActive: 'Application',

            baseMsgArray: [
                {
                    key: 'url',
                    text: 'public.belong'
                },
                {
                    key: 'name',
                    text: 'device.gateway_name'
                },
                {
                    key: 'nickname',
                    text: 'integration.gateway_nickname'
                },
                {
                    key: 'carrierName',
                    text: 'public.carrier'
                },
                {
                    key: 'mac',
                    text: 'device.gateway_mac'
                },
                {
                    key: 'sn',
                    text: 'device.gateway_serial_num'
                },
                {
                    key: 'code',
                    text: 'device.gateway_type'
                },
                {
                    key: 'status',
                    text: 'device.gateway_status'
                },
                {
                    key: 'edited',
                    text: 'device.activated'
                },
                {
                    key: 'config_status',
                    text: 'device.config_status'
                },
                {
                    key: 'create_time',
                    text: 'public.table_create_time'
                },
                {
                    key: 'power_status',
                    text: 'integration.battery_supply'
                },
                {
                    key: 'is_heart',
                    text: 'device.heartbeat_on'
                },
                {
                    key: 'description',
                    text: $t('public.table_desc')
                },
            ],
            netArray: [{
                key: 'extPanId',
                text: 'extPanId',
                content: ''
            },
            {
                key: 'channelPage',
                text: 'channelPage',
                content: ''
            },
            {
                key: 'channelMask',
                text: 'device.channel_mask',
                content: ''
            }],
            isMode: false,
            // 图片
            Upload: {},
            // 心跳
            hearTitle: '',
            isShow: false,
            hearQuery: {
                iDisplayStart: 0,
                iDisplayLength: 15,
                mac: null,
                startTime: null,
                endTime: null
            },
            tableData: [],
            totalAll: 0
        }
    },
    mounted() {

        if (this.$attrs['sensorWay'] === 'unknown') {
            this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'carrierName' && item.key !== 'config_status')
        }
        if (this.$attrs['sensorWay'] === 'unbind') {
            this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'carrierName')
        }
        if (this.$attrs['sensorWay'] === 'stop') {
            this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'config_status')
        }
    },
    methods: {
        // modeChange() {
        //     this.isMode = !this.isMode;
        // },
        // modeChanges(row) {

        //     this.isMode = !this.isMode;
        //     this.$parent.detailFn(row)
        // },
        confrimFn(row) {
            const { imageSuffix, imageUrl } = this.$refs['upload'].newUpload;
            const { id, is_heart, nickname, areaValue } = row;
            gatewayUpdate(
                {
                    id, is_heart, nickname,
                    description: areaValue,
                    uploadFileBase64: imageUrl,
                    uploadFileSuffix: imageSuffix
                }
            ).then(({ state }) => {
                if (state.code === 200) {
                    this.isMode = !this.isMode;
                    this.$message.success($t('integration.successfully_modified'));
                    this.$emit('changdetail', this.detailObj)
                    // this.$parent.getListFn()
                } else {
                    this.$message.error(state.msg)
                }
            })

        },
        hearFn() {
            this.isShow = true;
            this.hearTitle = `[${this.detailObj['name']}]` + $t('integration.gateway_heartbeat_history');
            this.hearQuery.mac = this.detailObj['mac']
            gatewayhistoryList(this.hearQuery).then(({ result }) => {
                this.tableData = result['result'];
                this.totalAll = result['pageInfo'].total;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.detailClass {
    display: flex;
}
</style>
